module.exports = __webpack_public_path__ + "static/img/16.1ae632a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/16.png
// module id = +dwb
// module chunks = 0